import { render } from "./BeachIcon.vue?vue&type=template&id=3c18f1c6&scoped=true"
import script from "./BeachIcon.vue?vue&type=script&lang=js"
export * from "./BeachIcon.vue?vue&type=script&lang=js"

import "./BeachIcon.vue?vue&type=style&index=0&id=3c18f1c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c18f1c6"]])

export default __exports__